<template>
    <ul>
        <li><router-link to="/supplier/dashboard"> ACCUEIL</router-link></li>
        <li><router-link to="/supplier/dossiers">DOSSIERS</router-link></li>
            
        <template v-if="authenticated">
            <li class="dropdown">
                <a class="">
                    <div class="text-center user-profil">
                        <i style="font-size:25px;" class="bi bi-person"></i><i class="bi bi-chevron-down"></i>
                       
                    </div>
                </a>
                <ul>
                    <li><router-link to="/user/profil">Profil Utilisateur</router-link></li>
                    <li><router-link to="/supplier/profil">INFORMATIONS </router-link></li>
                    <li><a class="dropdown-item" href="javascript:void(0)" @click="logout">Se deconnecter</a></li>
                </ul>
            </li>
        </template>
    </ul>
</template>
<script>
    import {mapActions} from 'vuex';
    import axios from "axios";
    export default{
        name:'SupplierNavbar',
        data: function(){
            return {
                authenticated:this.$store.state.auth.authenticated?this.$store.state.auth.authenticated:false,
            }
        },
        methods:{
            ...mapActions({
                signOut:"auth/signOut"
            }),
            async logout(){
                await axios.post(this.path+'auth/logout').then(()=>{
                    this.signOut()
                    this.authenticated = false;
                    window.location.href="/"
                    //this.$router.push({name:"home"})
                })
            }
        }
    }

</script>
<style scoped>
    .navbar a{
        text-decoration: none;
        font-weight: bolder;
    }

</style>